import { getApplicationEndpoint } from './application';
import { env, isDevelopment } from './env';
import { localPort } from './ports';
import { webConfig } from './webConfig';

/**
 * Return the fully qualified API url with protocol.
 */
export function getAPIEndpoint({
    acceptLocalhost = true,
    useAppDomain = false,
}: {
    /**
     * Accept a localhost API endpoint in development.
     * @default true
     */
    acceptLocalhost?: boolean;
    /**
     * Use the API endpoint served on the same domain as the application frontend to reduce CORS roundtrips.
     * @default false
     */
    useAppDomain?: boolean;
} = {}): string {
    if (acceptLocalhost && (isDevelopment || env === 'test')) {
        return `http://api.localhost:${localPort(7000)}`;
    }

    if (useAppDomain) {
        const applicationEndpoint = getApplicationEndpoint();

        // A bit of a hack until we move out of firebase hosting for dev environments.
        if (!applicationEndpoint.includes('.firebaseapp.com')) {
            return `${applicationEndpoint}/__api`;
        }
    }

    return `https://${webConfig.services.api.host}`;
}
